"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTradePwdWithOldPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var ResetTradePwdWithOldPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResetTradePwdWithOldPwd, _super);
    function ResetTradePwdWithOldPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '客户设置交易密码';
        _this.code = '101023';
        _this.desc = '客户设置交易密码';
        _this.requestParams = new password_1.ResetTradePwdWithOldPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ResetTradePwdWithOldPwd;
}(service_1.BaseService));
exports.ResetTradePwdWithOldPwd = ResetTradePwdWithOldPwd;
//# sourceMappingURL=resetTradePwdWithOldPwd.js.map